const heads = [{
  id: '1',
  name: 'Subject',
  class: 'w-100',
  prop: 'subject'
}];
  
  export default heads;